import { CloseOutlined } from "@ant-design/icons";
import { Alert, Button, Modal, Space } from "antd";
import axios from "axios";
import { message } from "components/Messages/Messages";
import { Company } from "interfaces/companies";
import React, { useState } from "react";

interface Props {
  company: Company;
  handleApproveCompany: (Company: Company) => void;
}

const ApproveCompany: React.FC<Props> = ({ company, handleApproveCompany }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const approveCompany = () => {
    Modal.confirm({
      title: <strong>Sikker på at du vil godkjenne bedriften?</strong>,
      icon: null,
      content: (
        <div>
          <p>Bedriften vil få tilgang til følgende funksjoner etter godkjenning:</p>
          <ul>
            <li>Logge inn på Bindeleddets bedriftsider.</li>
            <li>Publisere stillingsannonser.</li>
            <li>Se prismodell og bookinginformasjon.</li>
            <li>Booke bedriftspresentasjoner.</li>
            <li>Synlighet i bedriftskatalogen.</li>
          </ul>
          <p>
            <strong>Merk:</strong> Du kan manuelt deaktivere bedriftens tilgang til å booke bedriftspresentasjoner og
            vises i bedriftskatalogen etter godkjenning om ønskelig.
          </p>
        </div>
      ),
      okText: "Ja",
      cancelText: "Nei",
      onOk() {
        setLoading(true);
        axios
          .patch<Company>(`/companies/${company.id}/`, {
            approved: true,
            approved_for_booking: true,
            is_relevant: true,
          })
          .then(response => {
            message("success", "Bedriften er godkjent");
            handleApproveCompany(response.data);
            setLoading(false);
            // TODO: Send mail to company contact that company is approved
          })
          .catch(() => {
            message("error", "Feil ved godkjenning av bedrift");
            setLoading(false);
          });
      },
    });
  };
  return (
    <div>
      <Alert
        message="Bedriften er ikke godkjent"
        description={
          company.register_description
            ? `Årsak for registrering: \n ${company.register_description}`
            : "Årsak for registrering ikke oppgitt."
        }
        type="warning"
        showIcon
        closable
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "16px",
          position: "relative",
          color: "var(--dark)",
        }}
        closeIcon={
          <span
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
            }}
          >
            <CloseOutlined style={{ color: "var(--dark)" }} />
          </span>
        }
        action={
          <Space
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Button size="small" type="primary" onClick={approveCompany} loading={loading}>
              Godkjenn
            </Button>
          </Space>
        }
      />
    </div>
  );
};

export default ApproveCompany;
